import { useDispatch } from 'react-redux';
import { $actions } from 'Store/ducks';
import { useAsyncAction } from 'Hooks/Common';
import { CancelPreauthIntentPayload } from 'Interfaces/Billing';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: CancelPreauthIntentPayload) =>
    $actions.billing.cancelPreauthIntent(dispatch, payload),
  );
};
